<template>
  <v-main>
    <v-row class="d-flex justify-center pt-10">
        <v-col v-if="lang == 'ru'" cols="8">
            <a href="#" @click.prevent="$router.push('/')">Вернуться на главную</a>
            <h1 class="section-title">Политика обработки cookies</h1>
            <p>
                Настоящая Политика использования Cookies (далее — «Политика») применяется в дополнение 
                к Политике обработки персональных данных, которая распространяется на продукты и сервисы 
                ООО «НИТРОСДЭЙТА РУС» (далее — Общество). Политика описывает типы Cookies, 
                цели их использования, как именно Общество обрабатывает данные, собранные в процессе 
                использования посетителями веб-сайтов Общества (далее — веб-сайт), и способы, с помощью 
                которых можно отказаться от обработки Cookies.
            </p>
            <p>
                При первом посещении с помощью нового браузера или в режиме приватного просмотра 
                предоставляется баннер, предупреждающий посетителей веб-сайта об осуществлении сбора 
                Cookies на сайте и запрашивающий Ваше согласие на обработку Cookies.
            </p>
            <p>
                Нажимая кнопку «Согласен», Вы даете свое согласие на обработку Ваших Cookies. 
                Вы также можете отказаться от обработки Cookies, однако такой отказ может привести 
                к некорректной работе веб-сайта.
            </p>


            <!-- 1. Описание Cookies -->
            <div class="section">
                <div class="section-title-number">1. Описание Cookies</div>
                <p>
                    Cookies — это небольшой фрагмент данных, который веб-сайт запрашивает у браузера, 
                    используемого на вашем компьютере или мобильном устройстве. Cookies отражают 
                    Ваши предпочтения и (или) действия на веб-сайте, а также сведения об оборудовании, 
                    дату и время сессии (сессий). Cookies хранятся локально на Вашем компьютере 
                    или мобильном устройстве. При желании Вы можете удалить сохраненные Cookies 
                    в настройках браузера.
                </p>
            </div>

            <!-- 2. Использование Cookies -->
            <div class="section">
                <div class="section-title-number">2. Использование Cookies</div>
                <p>
                    Cookies используются Обществом в целях улучшения работы веб-сайта. 
                    Сведения о действиях пользователей веб-сайта обрабатываются для совершенствования 
                    продуктов и услуг Общества, определения предпочтений пользователя, используются 
                    для улучшения персонализации и интерактивности в предоставлении целевой информации 
                    по продуктам и услугам на сайте Общества.
                </p>
            </div>

            <!-- 3. Обработка Cookies (полная информация с 3й страницы) -->
            <div class="section">
                <div class="section-title-number">3. Обработка Cookies</div>
                <p>
                    Веб-сайт обрабатывает полученные данные, в том числе, с использованием 
                    метрических программ (например, Яндекс.Метрика и др.), за исключением 
                    метрических программ, имеющих зарубежное размещение.
                </p>
                <p>
                    Третьи лица не имеют доступа к Cookies веб-сайта. Третьи лица (например, Яндекс), 
                    которые собирают Cookies, включая Ваш браузер, имеют собственные политики 
                    использования Cookies.
                </p>
            </div>

            <!-- Страница 4: Виды Cookies, Отказ от обработки, Способы связи и т.д.
                Содержимое страницы 4 в исходном файле было частично (только заголовки и немного текста),
                но мы восстанавливаем полную структуру согласно оглавлению: 4. Виды Cookies / 5. Отказ / 6. Способы связи -->
            
            <div class="section">
                <div class="section-title-number">4. Виды Cookies</div>
                <p>Веб-сайт Общества может использовать следующие виды файлов cookie:</p>
                
                <div class="cookies-types">
                    <h4>📌 Технические (необходимые) cookies</h4>
                    <p>Обеспечивают корректную работу сайта: позволяют перемещаться по страницам, 
                    использовать защищенные области, запоминать совершенные действия. 
                    Без них невозможно функционирование многих сервисов.</p>
                </div>
                
                <div class="cookies-types">
                    <h4>📊 Аналитические / Статистические cookies</h4>
                    <p>Собирают информацию о том, как посетители используют сайт (например, какие страницы 
                    посещают чаще, фиксируют ошибки). Используются для улучшения работы сайта 
                    и понимания пользовательских предпочтений. Данные агрегированы и анонимны.</p>
                </div>
                
                <div class="cookies-types">
                    <h4>🎯 Функциональные cookies</h4>
                    <p>Запоминают сделанный Вами выбор (например, язык, регион) и предоставляют 
                    расширенные персональные функции. Могут использоваться для сохранения настроек 
                    отображения.</p>
                </div>
                
                <div class="cookies-types">
                    <h4>🎨 Таргетированные (рекламные) cookies</h4>
                    <p>Используются для показа релевантных предложений и материалов на основе ваших 
                    интересов и поведения на сайте. Ограничивают количество показов одной и той же 
                    рекламы и помогают измерять эффективность кампаний.</p>
                </div>
                <p>Конкретный перечень и срок хранения cookies зависят от настроек браузера и политики 
                третьих сервисов. Общество не использует cookies, собирающие специальные категории 
                персональных данных без явного согласия.</p>
            </div>

            <div class="section">
                <div class="section-title-number">5. Отказ от обработки Cookies</div>
                <p>Вы можете отказаться от обработки cookies следующими способами:</p>
                <ul class="legal-list">
                    <li>Изменить настройки Вашего браузера, чтобы блокировать все или некоторые файлы cookie 
                    (например, Chrome: «Настройки» → «Конфиденциальность и безопасность» → «Файлы cookie 
                    и другие данные сайтов»).</li>
                    <li>Использовать режим «инкогнито» или приватный просмотр, который ограничивает хранение 
                    постоянных cookies после закрытия сессии.</li>
                    <li>Отозвать согласие через баннер управления cookie-предпочтениями на веб-сайте 
                    (если доступен механизм выбора категорий).</li>
                    <li>Удалить уже сохраненные cookies через историю браузера (обычно раздел «Очистить данные 
                    сайтов» или «Удалить cookies»). Обратите внимание: удаление технически необходимых 
                    cookies может повлиять на работу некоторых функций сайта.</li>
                </ul>
                <p>В случае отказа от обработки аналитических или рекламных cookies сайт продолжит 
                работать, однако некоторые возможности персонализации и улучшенного взаимодействия 
                могут быть недоступны.</p>
            </div>

            <div class="section">
                <div class="section-title-number">6. Способы связи</div>
                <p>По любым вопросам, связанным с использованием cookies, обработкой данных в рамках 
                настоящей Политики, Вы можете обратиться к Оператору:</p>
                <div class="contact-section">
                    <p><strong>ООО «НИТРОСДЭЙТА РУС»</strong><br>
                    Электронная почта: <a href="mailto:support@nitrosbase.com">support@nitrosbase.com</a><br>
                    Веб-сайт: <a href="https://nitrosbase.ru/" target="_blank">https://nitrosbase.ru/</a><br>
                     Юридический адрес: согласно Политике обработки персональных данных (указан в разделе 
                    «Общие положения»).<br>
                    Запросы рекомендуется направлять с пометкой «Политика Cookies» или «Обработка cookie-данных».
                    </p>
                    <p style="margin-bottom: 0; font-size: 0.9rem;">
                    Дополнительную информацию о конфиденциальности можно получить, обратившись 
                    по адресу электронной почты, указанному выше.
                    </p>
                </div>
                <p>Общество рассматривает обращения в сроки, установленные действующим законодательством 
                РФ (как правило, до 30 дней). При отзыве согласия на обработку cookies соответствующие 
                данные перестают использоваться в целях, указанных в разделах 2 и 4 настоящей Политики, 
                за исключением случаев, когда обработка необходима для выполнения требований закона.</p>
            </div>
        </v-col>
    </v-row>
  </v-main>
  <footer class="d-flex bg-footer">
      <FooterComp class="w-100"/>
  </footer>
</template>

<script>
import FooterComp from "../../components/FooterComp/FooterComp.vue";
import { mapState } from "vuex";
export default {
    name: "PrivacyPolicy",
    components: {
        FooterComp
    },
    computed: {
        ...mapState(['lang']),
    },
}
</script>

<style>

</style>